import { type IGetWagerSettingsUseCase, type ISessionStoreRepository } from '../../../domain/entry.js';

/**
 * Use case for getting wager settings.
 *
 * @param wagerSettingsRepository Session store repository dependency
 * @returns Use case executor for getting wager settings
 */
export function getWagerSettingsUseCase(wagerSettingsRepository: ISessionStoreRepository): IGetWagerSettingsUseCase {
  return {
    execute: async ({ product, settingsKey }): ReturnType<IGetWagerSettingsUseCase['execute']> => {
      const settings = await wagerSettingsRepository.getWagerSettingsAsync(product, settingsKey);

      if (!settings) {
        // No user settings persisted in repository, return default
        return { correction: ['Live'] };
      }

      if (!settings.correction) {
        return {
          ...settings,
          correction: ['Live'],
        };
      }

      return {
        ...settings,
        correction: settings.correction,
      };
    },
  };
}
